import React from "react";
import { classNames } from "@/lib/util";

import "./EditableTextArea.scss";

type Props = {
    value: string;
    title: string;
    isDisabled: boolean;
    placeholder?: string;
    size?: "small" | "normal";
    onChange: (value: string) => void;
    onBlur?: (value: string) => void;
};

export default class EditableTextArea extends React.Component<Props> {
    onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const content = event.currentTarget.value;
        this.props.onChange(content);
    };

    onClick = (event: React.MouseEvent<HTMLTextAreaElement>) => {
        event.stopPropagation();
    };

    onBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
        const content = event.currentTarget.value;
        if (this.props.onBlur) {
            this.props.onBlur(content);
        }
    };

    render() {
        return (
            <div
                className={classNames("editable-text-area", {
                    "editable-text-area--small": this.props.size === "small",
                })}
            >
                <textarea
                    disabled={this.props.isDisabled ? true : undefined}
                    className="form-control"
                    value={this.props.value}
                    placeholder={this.props.placeholder || ""}
                    onChange={this.onChange}
                    onClick={this.onClick}
                    onBlur={this.onBlur}
                    title={this.props.title}
                />
            </div>
        );
    }
}
